import { Icon, IconSize } from "@blueprintjs/core"
import logo from "assets/images/logo_ios.png"
import React from "react"
import LoginFooter from "./LoginFooter"
import LoginForm from "./LoginForm"
const LoginPage = () => {
  return (
    <div className="vt-login-page">
      <div className="vt-company-details">
        <div className="vt-company-details-content">
          {/* <div className="vt-image-holder">
            <img src={""} alt="" />
          </div> */}

          {/* <h6 className="leading-snug"></h6> */}
          <h6 className="vt-support">Vesatogo Support</h6>
          <div className="vt-company-links">
            <a href="mailto:support@vesatogo.com">
              <Icon color="white" iconSize={IconSize.LARGE} icon="envelope" />
            </a>
            <a href="tel:8552072365">
              <Icon color="white" iconSize={IconSize.LARGE} icon="phone" />
            </a>
            <a href="https://vesatogo.com/">
              <Icon color="white" iconSize={IconSize.LARGE} icon="link" />
            </a>
          </div>
        </div>
      </div>
      <div className="vt-main-section">
        <div className="vt-login-form">
          <div className="vt-login-header">
            <div className="vt-brand-icon-container">
              <img
                src={logo}
                className="vt-brand-icon"
                alt="Vesatogo Innovations"
              />
            </div>
            <h5>Sign in to Vesatogo</h5>
          </div>

          <LoginForm />
        </div>
        <LoginFooter />
      </div>
    </div>
  )
}

export default LoginPage
